exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".love {\n  width: 0.9rem;\n  height: 0.7rem;\n  background-image: var(--my);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99;\n  -webkit-transition: all 5s linear;\n  transition: all 5s linear;\n  -webkit-transform: translate(0, 0vh);\n          transform: translate(0, 0vh);\n  -webkit-transform-origin: right bottom;\n          transform-origin: right bottom;\n  opacity: 0.7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/activity/nationalTemplate/DropScreen/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/activity/nationalTemplate/DropScreen/index.less
// module chunks = 0